'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { useRUMRecording } from '@/components/hooks/rum';
import { useTDPageview } from '@/components/hooks/td';

export default function ClientConfig() {
  const pathname = usePathname();
  useRUMRecording();
  useTDPageview();
  /**
   * Note: Scroll to top on route change
   */
  useEffect(() => {
    const id = requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      cancelAnimationFrame(id);
    };
  }, [pathname]);

  useEffect(() => {
    window.onerror = function (message, url, line, column, error) {
      // eslint-disable-next-line no-console
      console.log(message, url, line, column, error);
    };
  }, []);
  return null;
}
